"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantPeerSource = void 0;
const shuffling_1 = require("../../../../util/shuffling");
class ConstantPeerSource {
    constructor(peers) {
        this.peers = new Map(Array.from(peers).map((pi) => [pi.endpoint, pi]));
    }
    async getPeers(count) {
        let peers = Array.from(this.peers.values());
        shuffling_1.Shuffle.array(peers);
        if (peers.length > count) {
            peers = peers.slice(0, count);
        }
        return peers;
    }
    async getPeerForEndpoint(endpoint) {
        return this.peers.get(endpoint);
    }
}
exports.ConstantPeerSource = ConstantPeerSource;
//# sourceMappingURL=ConstantPeerSource.js.map